import moment from '../../../lib/moment';
import { formatDate } from '../../../lib/utils/date/formatDate';
import { DATE_FORMAT } from '../common/dateConstants';

/**
 *  페이지 이름
 */
export const MULTI_CHANNEL_PAGE_NAME = {
  ORDER_MANAGEMENT: '멀티채널 주문 관리',
  ORDER_CREATE: '멀티채널 주문 생성',
};

export const ORDER_STATUS = {
  ACCEPT: 'accept',
  PRODUCT_READY: 'productReady',
  DELIVERY_SHIPPING: 'deliveryShipping',
  DELIVERY_DONE: 'deliveryDone',
  CANCEL: 'cancel',
  RETURN: 'return',
} as const;

export const ORDER_STATUS_TEXT = {
  [ORDER_STATUS.ACCEPT]: '주문 접수',
  [ORDER_STATUS.PRODUCT_READY]: '상품 준비',
  [ORDER_STATUS.DELIVERY_SHIPPING]: '배송 중',
  [ORDER_STATUS.DELIVERY_DONE]: '배송완료',
  [ORDER_STATUS.CANCEL]: '취소',
  [ORDER_STATUS.RETURN]: '반품',
} as const;

export const ORDER_STATUS_CHECKBOX_LIST = [
  {
    id: ORDER_STATUS.ACCEPT,
    name: ORDER_STATUS_TEXT[ORDER_STATUS.ACCEPT],
  },
  {
    id: ORDER_STATUS.PRODUCT_READY,
    name: ORDER_STATUS_TEXT[ORDER_STATUS.PRODUCT_READY],
  },
  {
    id: ORDER_STATUS.DELIVERY_SHIPPING,
    name: ORDER_STATUS_TEXT[ORDER_STATUS.DELIVERY_SHIPPING],
  },
  {
    id: ORDER_STATUS.DELIVERY_DONE,
    name: ORDER_STATUS_TEXT[ORDER_STATUS.DELIVERY_DONE],
  },
  {
    id: ORDER_STATUS.CANCEL,
    name: ORDER_STATUS_TEXT[ORDER_STATUS.CANCEL],
  },
  {
    id: ORDER_STATUS.RETURN,
    name: ORDER_STATUS_TEXT[ORDER_STATUS.RETURN],
  },
];

export const DETAIL_SEARCH_TYPE = {
  // 멀티채널 주문번호
  MULTI_CHANNEL_ID: 'id',
  // 외부채널 관리번호
  EXTERNAL_ORDER_ID: 'externalOrderId',
  // 판매처
  MULTI_CHANNEL_NAME: 'multiChannelName',
  // 상품 ID
  PRODUCT_ID: 'productId',
  // 브랜드명
  BRAND_NAME: 'brandName',
  // 브랜드 ID
  BRAND_ID: 'brandId',
  // 바코드
  BARCODE: 'productOptionBarcode',
} as const;
export const DEFAULT_SEARCH_TYPE = DETAIL_SEARCH_TYPE.MULTI_CHANNEL_ID;

export const DETAIL_SEARCH_TYPE_TEXT = {
  [DETAIL_SEARCH_TYPE.MULTI_CHANNEL_ID]: '멀티채널 주문번호',
  [DETAIL_SEARCH_TYPE.EXTERNAL_ORDER_ID]: '외부채널 관리번호',
  [DETAIL_SEARCH_TYPE.MULTI_CHANNEL_NAME]: '판매처',
  [DETAIL_SEARCH_TYPE.PRODUCT_ID]: '상품 ID',
  [DETAIL_SEARCH_TYPE.BRAND_NAME]: '브랜드명',
  [DETAIL_SEARCH_TYPE.BRAND_ID]: '브랜드 ID',
  [DETAIL_SEARCH_TYPE.BARCODE]: '바코드',
};

export const DETAIL_SEARCH_TYPE_LIST = [
  {
    id: DETAIL_SEARCH_TYPE.MULTI_CHANNEL_ID,
    name: DETAIL_SEARCH_TYPE_TEXT[DETAIL_SEARCH_TYPE.MULTI_CHANNEL_ID],
  },
  {
    id: DETAIL_SEARCH_TYPE.EXTERNAL_ORDER_ID,
    name: DETAIL_SEARCH_TYPE_TEXT[DETAIL_SEARCH_TYPE.EXTERNAL_ORDER_ID],
  },
  {
    id: DETAIL_SEARCH_TYPE.MULTI_CHANNEL_NAME,
    name: DETAIL_SEARCH_TYPE_TEXT[DETAIL_SEARCH_TYPE.MULTI_CHANNEL_NAME],
  },
  {
    id: DETAIL_SEARCH_TYPE.PRODUCT_ID,
    name: DETAIL_SEARCH_TYPE_TEXT[DETAIL_SEARCH_TYPE.PRODUCT_ID],
  },
  {
    id: DETAIL_SEARCH_TYPE.BRAND_NAME,
    name: DETAIL_SEARCH_TYPE_TEXT[DETAIL_SEARCH_TYPE.BRAND_NAME],
  },
  {
    id: DETAIL_SEARCH_TYPE.BRAND_ID,
    name: DETAIL_SEARCH_TYPE_TEXT[DETAIL_SEARCH_TYPE.BRAND_ID],
  },
  {
    id: DETAIL_SEARCH_TYPE.BARCODE,
    name: DETAIL_SEARCH_TYPE_TEXT[DETAIL_SEARCH_TYPE.BARCODE],
  },
];

export const CANCEL_DISPOSER = {
  BRAND: 'brand',
  AMONDZ: 'amondz',
} as const;

export const CANCEL_DISPOSER_TEXT = {
  [CANCEL_DISPOSER.BRAND]: '브랜드',
  [CANCEL_DISPOSER.AMONDZ]: '아몬즈',
} as const;

export const CANCEL_DISPOSER_CHECKBOX_LIST = [
  {
    id: CANCEL_DISPOSER.BRAND,
    name: CANCEL_DISPOSER_TEXT[CANCEL_DISPOSER.BRAND],
  },
  {
    id: CANCEL_DISPOSER.AMONDZ,
    name: CANCEL_DISPOSER_TEXT[CANCEL_DISPOSER.AMONDZ],
  },
];

export const PERIOD_SEARCH_TYPE = {
  CREATE_DATE: 'createDate',
  CANCELLED_DATE: 'cancelledDate',
} as const;
export const PERIOD_SEARCH_TYPE_TEXT = {
  [PERIOD_SEARCH_TYPE.CREATE_DATE]: '멀티채널 주문생성일',
  [PERIOD_SEARCH_TYPE.CANCELLED_DATE]: '취소 처리일',
};

export const PERIOD_SEARCH_TYPE_SELECT_LIST = [
  { id: PERIOD_SEARCH_TYPE.CREATE_DATE, name: PERIOD_SEARCH_TYPE_TEXT[PERIOD_SEARCH_TYPE.CREATE_DATE] },
  {
    id: PERIOD_SEARCH_TYPE.CANCELLED_DATE,
    name: PERIOD_SEARCH_TYPE_TEXT[PERIOD_SEARCH_TYPE.CANCELLED_DATE],
  },
];

const DEFAULT_DATE_TYPE = PERIOD_SEARCH_TYPE.CREATE_DATE;
const DEFAULT_START_DATE = moment().startOf('day');
const DEFAULT_END_DATE = moment().endOf('day');

export const DEFAULT_PERIOD_SEARCH_OPTION = {
  type: DEFAULT_DATE_TYPE,
  quickDateIndex: 0,
  period: {
    startDate: formatDate(DEFAULT_START_DATE, DATE_FORMAT.FULL_DASH_FORMAT),
    endDate: formatDate(DEFAULT_END_DATE, DATE_FORMAT.FULL_DASH_FORMAT),
  },
};

export const DEFAULT_SEARCH_OPTION = {
  searchType: DEFAULT_SEARCH_TYPE,
  searchValue: '',
  status: '',
  cancelDisposer: '',
  dateType: DEFAULT_DATE_TYPE,
  startDate: DEFAULT_START_DATE.toISOString(),
  endDate: DEFAULT_END_DATE.toISOString(),
} as const;
